import { whatsappApi } from '@/core/api/whatsapp'

export const { useGetWhatsAppBindingsQuery, useRevokeWhatsAppBindingMutation } = whatsappApi
